export const getRoomMessages = (roomId) =>
  fetch(roomId ? `/rooms/${roomId}/messages.json` : '/messages.json')
    .then(response => response.json());
